import { useState, useEffect } from 'react';

export const enum ScreenSize {
    MOBILE,
    TABLET,
    DESKTOP,
    LARGE_DESKTOP
};

export class CurrentScreen {
    screenSize: ScreenSize = ScreenSize.DESKTOP;
    width: number = 0;
    
    get isMobile(): boolean {
        return this.screenSize === ScreenSize.MOBILE || this.screenSize === ScreenSize.TABLET;
    }
}

function getWindowDimensions() : CurrentScreen {
    let result: CurrentScreen = new CurrentScreen();

    const { innerWidth: width } = window;
      result.width = width;

    if (width < 768) {
        result.screenSize = ScreenSize.MOBILE;
        return result;
    }

    if (width < 992) {
        result.screenSize = ScreenSize.TABLET;
        return result;
    }

    if (width < 1200) {
        result.screenSize = ScreenSize.DESKTOP;
        return result;
    }

    result.screenSize = ScreenSize.LARGE_DESKTOP;
    return result;
}

export default function useWindowDimensions() : CurrentScreen {
    const [screenSize, setScreenSize] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setScreenSize(prev => {
                const next = getWindowDimensions();
                if (prev.screenSize === next.screenSize && prev.width === next.width) return prev;
                return next;
            });
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return screenSize;
}